document.addEventListener('DOMContentLoaded', function(){
  var overlay = document.getElementById('popup-overlay');
  var closeBtn = document.getElementById('popup-close');

  if (!overlay || !closeBtn) return;

  // --- Ablaufdatum festlegen ---
  // WICHTIG: Monate in JS: Januar = 0, Dezember = 11
  var endTime = new Date(2025, 11, 6, 10, 0, 0);  // 6.12.2025 10:00
  var now = new Date();

  // Wenn es nach dem Enddatum ist → Popup gar nicht anzeigen
  if (now >= endTime) {
    return; 
  }

  // --- Popup einblenden ---
  setTimeout(function() {
    overlay.style.display = 'flex';
    requestAnimationFrame(function() {
      overlay.style.opacity = '1';
    });
  }, 200);

  // --- Manuelles Schließen ---
  closeBtn.addEventListener('click', function() {
    overlay.style.opacity = '0';
    setTimeout(function(){
      overlay.style.display = 'none';
    }, 1000);
  });
});
